import WithholdingListItem from './WithholdingListItem'

export default WithholdingListItem
